import type { IxcMutualfundsV1FundOrderKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const MUTUAL_FUNDS_FUND_ORDER_BASE_PATH = getResolvedPath('/order/mutual-fund');

export const getMutualFundsFundOrderPath: EntityPathBuilder<IxcMutualfundsV1FundOrderKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      if (context?.keys?.accountId) {
        return getResolvedPath('/registration/account/$accountId/order/mutual-fund', context.keys);
      }

      return MUTUAL_FUNDS_FUND_ORDER_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.fundOrderId) {
        return undefined;
      }

      if (context?.keys?.accountId) {
        return getResolvedPath('/registration/account/$accountId/order/mutual-fund/$fundOrderId', context.keys);
      }

      return getResolvedPath(`${MUTUAL_FUNDS_FUND_ORDER_BASE_PATH}/$fundOrderId`, context.keys);
    }
  }
};

export function getMutualFundsFundOrderDetailPath(fundOrderId: string | undefined, accountId?: string) {
  if (!fundOrderId) {
    return undefined;
  }

  return getMutualFundsFundOrderPath({ kind: 'detail', keys: { fundOrderId, accountId } });
}
